// extracted by mini-css-extract-plugin
export default {"reviews":"reviews__p-yf8"};